// Component data-testid
export const CONTAINER_TEST_ID = 'filters-container';
export const FILTERS_BUTTON_TEST_ID = 'filters-button';
export const FILTERS_COUNT_TEST_ID = 'filters-count';
export const RESET_BUTTON_TEST_ID = 'filters-reset';
